/**
* In Hospital function is used to list the Hospital details and its functions declare this file
**/
import {Link} from 'react-router-dom'; 
import { useState,useEffect } from 'react';
import ApiService from './../../../services/ApiService';
import Pagination from './../../../shared/components/Pagination';
import { toast } from 'react-toastify';
import { goBack,convertS3privateToPublic } from './../../../services/UtilsService';
import DeleteModal from './../../../shared/modals/DeleteModal';
import { useTranslation } from 'react-i18next';

function Hospital() {
	//Intial state declaration
	const [hospitalList,setHospitalList]=useState([]);
	const [param,setParam]=useState({page:0,limit:10});
	const [modal,setModal]=useState({});
	const { t } = useTranslation();
	
	
	/** 
	* To handle search functions
	* @e - we get the event details from the change action
	**/
	const handleChange =async (e) => {
		e.preventDefault();
		const {name,value}=e.target;  
		setParam({...param,[name]:value,page:0});
	};
	
	/** 
	* To handle Sort functions
	* @e - we get the event details from the change action
	**/
	 const handleSortChange = (e) => {
		 e.preventDefault();
		const {name,value}=e.target;  
		setParam({...param,[name]:value});
	  };
	  
	/**
	* To delete hospital
	* @event - we  pass the value and id 
    * id - pass the particular hospital id
	* value - pass the boolean value
	**/
	const handleDelete = async (event) => {
		const {value,id}=event;
		var data={};
		data.recordId=id;
		if(value){
			await setModal({...modal,delete:!value})
			const response = await ApiService.deleteHospitalList(data);
			if(response.status===200){
				toast.success(response?.data?.message);
				setModal({...modal,value:value,modal:'success'})
				setParam({page:0,limit:10})
			}else{
				toast.error(response?.data?.message);
			}
		}
			  
	}
	  
	/** 
	* To handle pagination event
	* @data - we pass the page number
	**/
	  const handlePaginate=(data)=>{  
		  setParam({...param,page:data});
	  };
	
	
	//components initialize function and api handling
	useEffect(()=>{(async () => {
		const response = await ApiService.organizationList(param);
		setHospitalList(response.data);
		})();
	},[param]);
	
	//To close modal
	const handleClose=()=>setModal({});
	
	
  return (
   <main id="main" className="main">
   
	{/*Import DeleteModal*/}
	{Object.keys(modal).length !==0 && modal.delete && <DeleteModal data={modal} handleDelete={handleDelete} handleClose={handleClose} />}
		 {/*Page Title Section*/}
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('sidebar.hospital')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item"><Link to="/admin/dashboard">{t('sidebar.home')}</Link></li>
					  <li className="breadcrumb-item active">{t('sidebar.hospital')} </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		{/*End Page Title Section*/}
		
		{/* Page Content Section */}
		<section className="pagesection">
			<div className="row my-3">
				{/*Search*/}
				<div className="col-xxl-6 col-lg-6 d-flex">
					<div className="input-group input-group-sm me-2 w-50">
					  <input type="text" name="search" value={param.search?param.search:''}
						onChange={handleChange} className="form-control" placeholder={t('common.search')} />
					  <button className="btn btn-tmBlue" type="button"><i className="iconly-Light-Search"></i></button>
					</div>
				</div>
				{/* End Search*/}
				
				<div className="col-xxl-6 col-lg-6">
					<Link to='/admin/add-hospital' className="btn btn-sm btn-outline-tmBlue float-end">
						<i className="iconly-Bold-Plus align-middle me-1"></i> {t('common.addHospital')}
					</Link>
					{/*Sort*/}
					<div className="dropdown float-end me-3">
					  <a className="btn btn-sm btn-outline-tmBlue dropdown-toggle" href="javascript;" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false" > {t('common.sort')} </a>
					  <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
					  <li>
						<button className={param.sort ==='added' ? 'dropdown-item active' : 'dropdown-item'} type="button" value="added" name="sort" onClick={handleSortChange} > {t('common.newlyAdded')} </button>
					  </li>
					  <li>
						<button className={param.sort ==='a-z' ? 'dropdown-item active' : 'dropdown-item'} type="button" value="a-z" name="sort" onClick={handleSortChange} > {t('common.alphabeticalOrder')} </button>
					  </li>
					  </ul>
					</div>
					{/*End Sort*/}
				</div>
			</div>
			 {/*Table*/}
			<div className="row my-3">
				<div className="col-xxl-12">
					<div className="table-responsive">	
						<table className="table table-borderless theme-table">
							<thead>
							  <tr>
								<th scope="col">{t('profile.hospitalName')}</th>
								<th scope="col">{t('profile.location')}</th>
								<th scope="col">{t('table.contactNumber')}</th>
								<th scope="col">{t('profile.emailAddress')}</th>
								<th scope="col" className="text-center">{t('sidebar.physician')}</th>
								<th scope="col" className="text-center">{t('sidebar.parents')}</th>
								<th scope="col" className="text-center">{t('profile.action')}</th>
							  </tr>
							</thead>
						{hospitalList && hospitalList?.details?.length ? (
							<tbody>
							{hospitalList && hospitalList.details && hospitalList.details.map(item => (
								<tr key={item.id}>
									<td >
							     <Link to={'/admin/hospital/'+item.id}>
											<div className="d-flex align-items-center ps-1">
												<div className="avtar-img">
													<span className="rounded-circle">
													{item?.photo==='default.png'?<img src="/assets/img/logo-img.png" alt="IMG" />:<img src={convertS3privateToPublic(item?.photo)} alt="IMG"  />}
													</span>
												</div>
												<div className="ms-2">
													<h5 className="table-title text-capitalize">{item?.name}</h5>
												</div>
											</div>
										</Link>
									</td>					
									<td className="text-capitalize">{item?.city+', '+item.state}</td>						
									<td style={{whiteSpace:'nowrap'}}>{item?.mobileNumber?
									item?.countryCode+' '+item?.mobileNumber:'--'}</td>
									<td>{item?.email ? (
											<a href={`mailto:${item?.email}`}>{item?.email}</a>
										) : (
											'--'
										)}</td>
									<td className="text-center"><span>{item?.physician_count?item?.physician_count:0}</span></td>						
									<td className="text-center"><span>{item?.parent_count?item?.parent_count:0}</span></td>
									<td className="text-center fw-normal">
										<Link to={'/admin/edit-hospital/'+item.id} className="text-warning d-inline"><i className="iconly-Bold-Edit align-middle me-2"></i></Link>
										<Link className="text-danger d-inline" onClick={()=>setModal({delete:true,id:item?.id})}><i className="iconly-Bold-Delete align-middle"></i></Link>
									</td>
								</tr>
								))}
							</tbody>
						) : (
						  <tbody>
							<tr>
							  <td colSpan="7" className="text-center">{t('common.noRecord')}</td>
							</tr>
						  </tbody>
						)}
						</table>
					</div>
				</div>
			</div>
			{/*End Table*/}
			
			{/*Pagination*/}
			{hospitalList && hospitalList.length !==0 && hospitalList?.details?.length!==0 && <div className="row my-3">
				<div className="col-xxl-12 d-flex justify-content-center">
					<Pagination page={param.page} handlePaginate={handlePaginate} total={hospitalList.counts}  />
				</div>
            </div>}
			{/*End Pagination*/}
		</section>
		{/* End Page Content Section */}
		
	</main>
  );
}

export default Hospital;
